import { loyaltyConsentCookieValue } from '@/infrastructure/Configuration'

export default {
  loading: 0,
  rates: [],
  rooms: [],
  focus: undefined,
  availabilityRequest: {},
  selectedPayment: {},
  isLogged: false,
  error: undefined,
  exchangeRates: [],
  selectedCurrency: { key: 'hotelCurrency', value: 'Hotel currency' },
  matchesRatesFound: false,
  customer: undefined,
  labelsLoaded: false,
  nearbyHotels: [],
  nearbyPlace: {},
  selectedHotel: {},
  socialMedia: [],
  overviewPath: '',
  tmsCode: '',
  ratesHavePoints: false,
  currentCategory: '',
  loadingRate: undefined,
  checkInTime: '',
  checkOutTime: '',
  displayLoyaltyRates: loyaltyConsentCookieValue,
  memberOnlyRate: false,
  isTier: false,
  travelAgencyCustomerId: '',
  promotionalCodeGroupId: '',
  onlyAccessible: false,
  hotelName: '',
  minNightsPerStay: null,
  qubitTracker: null
}
